module.exports = __webpack_public_path__ + "img/ursa_major.8a4cc976.png";